import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Typography from '../../../UniformComponents/Typography'
import OSSChartSlot from './components/OSSChartSlot'

const OSS = observer(({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <div className="pp-chart-slot-container">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', backgroundColor: 'white', borderRadius: 6, padding: '5px 10px' }}>
                <OSSChartSlot
                    store={store}
                    chartKey={`${store.activeSlide.id}-${0}`}
                    position={0}
                />
            </div>
        </div>
    </div>
))

export default OSS
